module.exports = __webpack_public_path__ + "static/media/h6.8d01dfe8.jpg";